import { render } from "./DownGuardados.vue?vue&type=template&id=6673ed9f&scoped=true"
import script from "./DownGuardados.vue?vue&type=script&lang=js"
export * from "./DownGuardados.vue?vue&type=script&lang=js"

import "./DownGuardados.vue?vue&type=style&index=0&id=6673ed9f&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6673ed9f"

export default script